<template>
<div class="page-business-consulting container">
  <van-list class="container-flex list-content"  :class="dataList.length > 0 ? 'bg' : ''" v-model="loading"
                :finished="isAll"
                finished-text="没有更多了"
                @load="scrollToLower">
        <div class="list-content-item" v-for="(item,index) in dataList" :key="index"  @click="selectClick(item)">
            <div class="content-item-info">
                <div class="content-item-info-flex">
                    <div class="item-name">
                        {{item.createTime}} <div class="status" :class="item.consultStatus == 2 ? 'no':''">{{item.consultStatusDesc}}</div>
                    </div>
                    <div class="item-text">业务类型：{{item.consultTypeDesc}}</div>
                </div>
                <div class="right-box-icon v-center">
                    <img class="right-icon" src="../../assets/image/my-cell-icon-right.png" />
                </div>
            </div>
        </div>
        <view class="no-list-data" v-if="dataList.length > 0">暂无更多数据</view>
        <div class="no-data-box" v-if="dataList.length == 0">
            <img class="no-data-icon" src="../../assets/image/mall-no-address.png" />
            <div class="no-data-text">暂无咨询</div>
        </div>
    </van-list>
    <div class="add-btn-box">
        <pi-button type="primary" block @click="addClick">新增咨询</pi-button>
    </div>
</div>
</template>

<script>
import { getConsultList } from "../../common/api/index";
import { List } from "vant";
export default {
  name: "business-consulting",
  components: {
   [List.name]: List,
  },
  data() {
    return {
      loading: false,
      isAll: false,
      dataList: [],
      from: {
        globalPageIndex: 1,
        globalPageSize: 10,
      }
    };
  },
  methods: {
    scrollToLower(){
        this.from.globalPageIndex = this.from.globalPageIndex + 1;
        this.getMallorderPage();
    },
    async getConsultList(){
      this.loading = true
      let ret = await getConsultList(this.from);
      if (ret.status === 0) {
        let data = ret.data || [];
        this.dataList.push(...data);

        if(this.dataList.length >= ret.total){
          this.isAll = true;
        }
      }
      this.loading = false
    },
    addClick(){
      this.$router.push("/business-consulting-add");
      this.$common.remove('businessConsulting');
    },
    selectClick(item){
      this.$common.save('businessConsulting',item);
      this.$router.push("/business-consulting-add?id="+item.id);
    }
  },
  mounted() {
    this.getConsultList();
  },
};
</script>

<style lang="less">
@import "../../assets/less/old/var.less";
.page-business-consulting{
    
  .list-content{
      padding: 0.20rem;
      position: relative;
  }
  .list-content-item{
      background-color: #fff;
      border-radius: 0.12rem;
      margin-top: 0.20rem;
      font-size: 0.24rem;
      line-height: 0.33rem;
      color: #666;
  }
  .list-content-item:first-child{
      margin-top: 0;
  }
  .content-item-info{
      padding: 0.20rem;
      display: flex;
  }
  .content-item-info-flex{
      flex: 1;
  }
  .content-item-info .item-name{
      font-size: 0.28rem;
      line-height: 0.40rem;
      color: #000;
  }
  .content-item-info .status{
      display: inline-block;
      padding: 0 0.1rem;
      color: #fff;
      background-color: @main-color;
      line-height: 0.28rem;
      font-size: 0.18rem;
      vertical-align: middle;
      margin-left: 0.2rem;
  }
  .content-item-info .status.no{
    background-color: @orange
  }
  .content-item-info .item-text{
      margin-top: 0.13rem;
      font-size: 0.24rem;
      color:#666
  }

  
  .right-box-icon{
      padding-left: 0.20rem;
  }
  .right-icon{
    width: 0.2rem;
  }
  .add-btn-box{
    padding: 0.20rem;
  }
  .no-data-box{
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      text-align: center;
  }
  .no-data-icon{
      width: 1.50rem;
      height: 0.97rem;
  }
  .no-data-text{
      margin-top: 0.30rem;
      color: #999
  }
}
</style>
